import RFB from '@novnc/novnc/core/rfb.js';
$(function () {
    function connect(self) {
        var connectDetailUrl = self.data('vnc-console');
        $.post(connectDetailUrl, function (res) {
            if (res.success) {
                const rfb = new RFB(self[0], res.endpoint, {
                    credentials: {
                        password: res.password
                    }
                });
                rfb.focusOnClick = true;
                rfb.scaleViewport = true;
                rfb.addEventListener("disconnect", function () {
                    setTimeout(function () {
                        connect(self);
                    }, 1000);
                })
            }
        }, "json");
    }
    $('[data-vnc-console]').each(function () {
        const self = $(this);
        connect(self);p
    });
})
